import React, { useRef, useContext } from 'react';
import numbro from 'numbro';
import cn from 'classnames';
import _get from 'lodash/get';

import { findAllValues } from 'utils/DICTIONARY';
import { UiKit } from 'components';
import { ReactTablesContext } from 'components/ReactTable';

export default function TableRefinementList({
  facetKey = '',
  masterKey = '',
  excludeKeys = [],
  listClassName = '',
  listItemClassName = '',
  preventHiding = false
}) {
  const {
    facets,
    refine,
    refinements,
    facetsToRefinementKeyMap,
    searchState: { isFetchingFacets }
  } = useContext(ReactTablesContext);
  const listMap = useRef(findAllValues(masterKey)).current;

  const facetData = _get(facets, facetKey, {});
  const refinementKey = _get(facetsToRefinementKeyMap, facetKey, facetKey);
  const refinementData = _get(refinements, `${refinementKey}.values`, {});

  const createlistItems = (data = {}, formatTitle = val => val) => {
    const dataSet = { ...data };
    excludeKeys.forEach(key => delete dataSet[key]);
    return Object.keys(dataSet).map(key => {
      const title = formatTitle(key);
      const count = _get(facetData, key, 0);
      const isRefined = !!_get(refinementData, key, false);
      const value = { type: 'list', value: key, attribute: refinementKey };

      const formattedCount = numbro(count).format({
        thousandSeparated: true,
        mantissa: 0
      });
      const hasOptions = count > 0;
      return (
        <li
          key={key}
          className={cn(
            'table-filters__refinement-list--item',
            listItemClassName
          )}
        >
          <UiKit.Checkbox
            label={title}
            checked={isRefined}
            disabled={isFetchingFacets || !hasOptions}
            onChange={() => refine(value)}
          />
          <span className="filter-count">{formattedCount}</span>
        </li>
      );
    });
  };

  const filters = !masterKey
    ? createlistItems(facetData)
    : createlistItems(listMap, key => _get(listMap, key, key));

  return preventHiding || Object.keys(facetData).length > 0 ? (
    <ul className={cn('table-filters__refinement-list', listClassName)}>
      {filters}
    </ul>
  ) : (
    <div className="text-muted">No filters available!</div>
  );
}
